import React, { useState, useEffect } from "react";
import Layout from "../Component/Layout";
import TextEditor from "../Component/TextEditor";
import Button from "../Component/Button";
import axios from "axios"; // or use fetch
import REACT_APP_API_URL from "../utils/constant";
import { showToast } from "../helper/Toster";

const Privacy = () => {
  const [content, setContent] = useState("");
  // const [message, setMessage] = useState("");
  const [intialvalue, setintialvalue] = useState("");

  // Load existing content
  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get(`${REACT_APP_API_URL}get-cms`, {
          params: { type: "terms" },
        });
        // console.log("response.data.data.description",response.data.data.description)
        if (response.data.code === 200 && response.data.data) {
          setintialvalue(response.data.data.description); // note: your field is 'descrition'
        }
      } catch (error) {
        console.error("Error fetching content:", error);
      }
    };

    fetchContent();
  }, []);

  console.log(content);

  // Save new content
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(content);
    try {
      const response = await axios.post(`${REACT_APP_API_URL}add-cms`, {
        type: "terms",
        description: content ? content : intialvalue, // match the backend field
      });
      console.log("response:kjhg", response);
      if (response.data.code === 200) {
        // setMessage("Terms & conditions saved successfully!");
        showToast("success", "Terms & conditions saved successfully");
      } else {
        // setMessage("Failed to save content.");
        showToast("error", "Failed to save content");
      }
    } catch (error) {
      console.error("Error saving content:", error);
      // setMessage("Error saving content.");
      showToast("error", "Error saving content");
    }

    // setTimeout(() => setMessage(""), 2000);  
  };

  return (
    <Layout>
      <div className="row">
        <div className="col-12">
          {/* {message && (
            <div
              className={`alert ${
                message.includes("successfully")
                  ? "alert-success"
                  : "alert-danger"
              }`}
            >
              {message}
            </div>
          )} */}
          <form onSubmit={handleSubmit}>
            <TextEditor
              content={intialvalue}
              onChange={(html) => setContent(html)}
            />
            <Button className="px-5 mt-3" type="submit">
              Save
            </Button>
          </form>
        </div>
      </div>
    </Layout>
  );
};
export default Privacy;
